// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1WJhd","head":"ProcedureTableInfo_head__37g0C"};